import _ from 'lodash'
import React, { Component } from 'react';
import ReactDOM, { findDOMNode } from 'react-dom';
import { connect } from 'react-redux'
import { DragSource, DropTarget } from 'react-dnd';
import { ItemTypes } from './Constants';
import { setRepeatFields } from './actions/index.js'
import FieldsRender from './FieldsRender.js'
import deepcopy from 'deepcopy';

const itemSource = {
  beginDrag(props){
    return {
      id: props.id,
      index: props.index
    }
  }
}

const itemTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    if (dragIndex === hoverIndex) {
      return;
    }

    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    const clientOffset = monitor.getClientOffset();
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    props.fields.swap(dragIndex, hoverIndex);
    monitor.getItem().index = hoverIndex;
  }
};

class RepeatItem extends Component {

  handleItemClick(value){
    const { parentKey, state:{ sppbForm } } = this.props

    this.props.onHandleRowClick( value );

    if ( value !='none' ) {
      if ( sppbForm.mainForm.addonName == 'accordion' || sppbForm.mainForm.addonName == 'tab' || sppbForm.mainForm.addonName == 'sp_carouselpro' || sppbForm.mainForm.addonName == 'carouselpro' ) {
        if (sppbForm.form == 'mainForm') {
          this.props.setRepeatFields( parentKey, value )
        }
      }
    }
  }

  RepeatItemClone(index){
    const { fields } = this.props

    let poopNodeId = (new Date).getTime();
    var currentFieldVal = deepcopy( fields.get(index));

    if ( _.isObject(currentFieldVal.content) ) {
      currentFieldVal.content.filter(function(item){
        item.id = poopNodeId++
        return item;
      })
    }

    fields.push(currentFieldVal);
  }

  render(){
    const { index, openRow, element, isDragging, parentKey, flOptions, state, thisFormName, connectDropTarget, connectDragPreview, connectDragSource } = this.props



    const dragStyle={
      opacity:isDragging?'.5':'1'
    }

    let repeatFieldValues = {}

    if ( thisFormName == "sppbForm" ) {
      repeatFieldValues = state.form.sppbForm.values[parentKey][index]
    }

    if ( thisFormName == "insideAddonForm" ) {
      repeatFieldValues = state.form.insideAddonForm.values[parentKey][index]
    }

    return connectDragPreview(connectDropTarget(
      <div className="sppb-repeatable-field" style={dragStyle}>
          <div className="sppb-repeatable-field-title">
            {
              openRow == 'none' &&
              connectDragSource(
                <span className="sppb-move-repeat-item"><i className="fa fa-arrows-v"></i></span>
              )
            }
            {
              this.props.fields.get(index).title
              ?
              <span className="sppb-repeat-item-title" onClick={ (e) => { e.preventDefault(); this.handleItemClick(index)}}> {this.props.fields.get(index).title} </span>
              :
              <span className="sppb-repeat-item-title" onClick={ (e) => { e.preventDefault(); this.handleItemClick(index)}}> Item { this.props.index + 1 } </span>
            }
            <span className="sppb-repeat-item-action-btns" style={{marginLeft: 'auto'}}>
              {
                openRow != index
                ?
                <span className="sppb-repeatable-field-action-btn">
                  <button onClick={ (e) => { e.preventDefault(); this.handleItemClick(index)}} ><i className="fa fa-cog" /></button>
                  <button onClick={ (e) => { e.preventDefault(); this.RepeatItemClone(index)}} ><i className="fa fa-clone" /></button>
                  <button  className="sppb-repeatable-field-delete-btn" onClick={ (e) => {
                    e.preventDefault();
                    if (!window.confirm("Do you really want to delete this item?")) {
                      return;
                    }
                    this.props.onHandleRemoveItemRowClick(index)
                    }} ><i className="fa fa-trash-o" /></button>
                </span>
                :
                  <button className="sppb-repeatable-field-apply" onClick={ (e) => { e.preventDefault(); this.handleItemClick('none')}} ><i className="fa fa-check" /> Apply</button>
              }
            </span>
          </div>
        {
          openRow == index &&
          <div className="sppb-repeatable-fields">
            <FieldsRender
              fieldsAttr = { flOptions.attr }
              values = { repeatFieldValues }
              parentKey = { parentKey }
              index = { index }
              element = { element }
            />
          </div>
        }
        {
          openRow == index &&
          <div className="sppb-repeatable-field-footer sppb-text-right">
              <button onClick={ (e) => { e.preventDefault(); this.handleItemClick('none')}} ><i className="fa fa-check" /></button>
          </div>
        }
      </div>
    ))
  }
}

var DragSourceDecorator = DragSource(ItemTypes.FORMREITEM, itemSource,
  function(connect, monitor) {
    return {
      connectDragSource: connect.dragSource(),
      connectDragPreview: connect.dragPreview(),
      isDragging: monitor.isDragging()
    };
  }
);

var DropTargetDecorator = DropTarget(ItemTypes.FORMREITEM, itemTarget,
  function(connect) {
    return {
      connectDropTarget: connect.dropTarget()
    };
  }
);

const mapStateToProps = (state) => {
  return {
    state
  };
}

const mapDispatchToProps = ( dispatch ) => {
  return {
    setRepeatFields: ( fieldName, rfieldIndex ) => {
      dispatch( setRepeatFields( fieldName, rfieldIndex ) )
    }
  }
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DropTargetDecorator(DragSourceDecorator(RepeatItem)));



// WEBPACK FOOTER //
// ./src/helpers/form/RepeatItem.js